// tslint:disable:max-line-length
import * as React from "react";
import { iconStyle } from './icon.style';
interface IProps {
  style?: React.CSSProperties;
}
export const CircleIcon: React.FC<IProps> = (props) =><svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{...iconStyle, ...props.style}}>
  <path d="M12,24C5.38,24,0,18.62,0,12S5.38,0,12,0s12,5.38,12,12-5.38,12-12,12ZM12,2C6.49,2,2,6.49,2,12s4.49,10,10,10,10-4.49,10-10S17.51,2,12,2Z"/>
</svg>


// WEBPACK FOOTER //
// ./src/icons/Circle.tsx